import React, { MouseEventHandler } from 'react'

export interface MenuToggleProps {
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined
}

export const MenuToggle = ({ onClick }: MenuToggleProps) => {
  return (
    <button
      className="px-4 py-1 border-2 border-secondary text-primary rounded uppercase"
      onClick={onClick && onClick}
    >
      Menu
    </button>
  )
}
